export const NOTIFICATIONS_SET_UNREAD_COUNT = "NOTIFICATIONS_SET_UNREAD_COUNT";

export function setUnreadCount(count: number) {
    return {
        type: NOTIFICATIONS_SET_UNREAD_COUNT,
        payload: count,
    };
}
